module.exports = __webpack_public_path__ + "static/media/postgresql-plain.f7b6290a.svg";